var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageLevel1Empty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 210,
    viewBox: "0 0 500 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3362_11335)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 210,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 36.9297H500V210H0V36.9297Z",
    fill: "#F4F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.309 37.2422H500V210H245.309V37.2422Z",
    fill: "url(#paint0_linear_3362_11335)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7766,
    y: 49.6484,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7766,
    y: 82.0547,
    width: 55.9161,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7766,
    y: 104.461,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7766,
    y: 125,
    width: 70.4691,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.848,
    y: 49.6484,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.92,
    y: 49.6484,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.992,
    y: 49.6484,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7766,
    y: 14.4961,
    width: 104.323,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.818,
    y: 14.4961,
    width: 104.323,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.859,
    y: 14.4961,
    width: 104.323,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 14.4961,
    width: 104.323,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.408 50.0484L476.224 53.2334L473.038 50.0474C472.943 49.9543 472.815 49.9024 472.681 49.9029C472.548 49.9035 472.421 49.9565 472.326 50.0504L471.626 50.7514C471.578 50.7974 471.54 50.8525 471.514 50.9135C471.487 50.9745 471.474 51.0402 471.473 51.1066C471.473 51.173 471.486 51.2388 471.512 51.3001C471.537 51.3614 471.575 51.4169 471.622 51.4634L474.807 54.6474L471.623 57.8334C471.53 57.9288 471.478 58.057 471.479 58.1903C471.48 58.3235 471.533 58.4511 471.627 58.5454L472.327 59.2454C472.533 59.4524 472.843 59.4454 473.039 59.2494L476.225 56.0644L479.409 59.2494C479.504 59.3425 479.633 59.3942 479.766 59.3935C479.899 59.3927 480.027 59.3395 480.121 59.2454L480.822 58.5454C480.87 58.4994 480.908 58.4442 480.934 58.3832C480.96 58.3221 480.974 58.2565 480.974 58.1901C480.974 58.1237 480.961 58.0579 480.936 57.9966C480.91 57.9354 480.872 57.8799 480.825 57.8334L477.639 54.6474L480.825 51.4634C480.918 51.3682 480.97 51.2401 480.97 51.1068C480.969 50.9736 480.916 50.8459 480.822 50.7514L480.122 50.0514C480.075 50.0034 480.019 49.9652 479.957 49.9389C479.896 49.9126 479.829 49.8989 479.762 49.8984C479.696 49.899 479.631 49.9125 479.571 49.9382C479.51 49.964 479.455 50.0014 479.409 50.0484H479.408Z",
    fill: "#9FADBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.017 147.665C433.017 154.107 427.795 159.329 421.353 159.329C414.91 159.329 409.688 154.107 409.688 147.665C409.688 141.222 414.91 136 421.353 136C427.795 136 433.017 141.222 433.017 147.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.984 164.161C452.857 163.088 451.087 163.088 449.961 164.161L430.792 182.417L424.938 176.177C423.786 174.949 421.836 174.949 420.684 176.177L411.003 186.496C409.256 188.358 410.576 191.407 413.13 191.407H475.302C477.934 191.407 479.219 188.195 477.313 186.379L453.984 164.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.74228e-8,
    y1: 36.2422,
    x2: 500,
    y2: 36.2422,
    stroke: "#9FADBC",
    strokeWidth: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 498,
    height: 208,
    rx: 9,
    stroke: "#9FADBC",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3362_11335",
    x1: 500,
    y1: 210,
    x2: 234.114,
    y2: 179.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#00B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842804,
    stopColor: "#00B4D8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3362_11335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 210,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLevel1Empty);
export default __webpack_public_path__ + "static/media/Image-level1-empty.2127c98ca26d64108333d178ccd97605.svg";
export { ForwardRef as ReactComponent };